/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/merchantStaging/types";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_SortingState,
  MaterialReactTable,
} from "material-react-table";
import TableActions from "../../../common/table/TableActions";

export interface Props {
  merchant: Data[];
  merchantCount: number;
  pagination: MRT_PaginationState;
  setPagination: (values: MRT_PaginationState) => void;
}

interface RowData {
  id: string;
  tid?: string;
  mid?: string;
}

export class MerchantStageTableParams {
  page = 0;
  pageSize = 10;
  pageCount = 0;
  orderBy = -1;
  orderDirection = "";
  searchText = "";
  searchField = "TID";
  totalCount = 1;
  cache?: string = 'ignore';
}

export const ColumnToRecordMapping = [
  "id",
  "attributes.Name",
  "attributes.MID",
];

const mapDataToTable = (merchant: Data[]): RowData[] => {
  return merchant.map((data) => {
    return {
      id: data.id,
      tid: data.TID,
      mid: data.MID,
    };
  });
};

export default function MerchantStageTable({
  merchant,
  merchantCount,
  pagination,
  setPagination,
}: Props) {
  const history = useHistory();
  const [sorting, setSorting] = useState<MRT_SortingState>([]);

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        accessorKey: "tid",
        header: "TID",
      },
      {
        accessorKey: "mid",
        header: "MID",
      },
    ],
    []
  );

  const viewAction = (rowData: RowData) => {
    history.push(`/staged-terminal/view/${rowData.id}`);
  };

  return (
    <MaterialReactTable
      columns={columns}
      data={mapDataToTable(merchant)}
      getRowId={(row) => row.id}
      initialState={{ showColumnFilters: false, density: "spacious" }}
      enableTopToolbar={false}
      enableColumnFilters={false}
      enableColumnActions={false}
      manualFiltering
      manualPagination
      onPaginationChange={setPagination}
      onSortingChange={setSorting}
      rowCount={merchantCount}
      muiTablePaginationProps={{
        rowsPerPageOptions: [10],
      }}
      state={{
        pagination,
        sorting,
      }}
      enableRowActions
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 100,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="Merchant"
          onView={() => viewAction(row.original)}
        />
      )}
    />
  );
}
